/*---------------------------------------------------------------------------------------------
* Copyright (c) Bentley Systems, Incorporated. All rights reserved.
* See LICENSE.md in the project root for license terms and full copyright notice.
*--------------------------------------------------------------------------------------------*/

export const runtimeEnv = {
  REACT_APP_AUTH_URL: process.env.REACT_APP_AUTH_URL!,
  REACT_APP_LOGOFF_REDIRECT_URL: process.env.REACT_APP_LOGOFF_REDIRECT_URL!,
  REACT_APP_IDENTITY_CLIENT_ID: process.env.REACT_APP_IDENTITY_CLIENT_ID!,
  REACT_APP_REDIRECT_URL: process.env.REACT_APP_REDIRECT_URL!,
  REACT_APP_SILENT_REDIRECT_URL: process.env.REACT_APP_SILENT_REDIRECT_URL!,
  REACT_APP_AI_KEY: process.env.REACT_APP_AI_KEY!,
  REACT_APP_SEARCH_KEY: process.env.REACT_APP_SEARCH_KEY!,
  REACT_APP_SEARCH_APP_ID: process.env.REACT_APP_SEARCH_APP_ID!,
  REACT_APP_SEARCH_INDEX: process.env.REACT_APP_SEARCH_INDEX!,
  REACT_APP_BUDDI_REGION: process.env.REACT_APP_BUDDI_REGION!,
  REACT_APP_SCOPE: process.env.REACT_APP_SCOPE!,
  REACT_APP_TARGET_ORIGIN: process.env.REACT_APP_TARGET_ORIGIN!,
  REACT_APP_LD_KEY: process.env.REACT_APP_LD_KEY!,
  REACT_APP_COMPILER_URL: process.env.REACT_APP_COMPILER_URL!,
  REACT_APP_PREFERRED_VERSION: process.env.REACT_APP_PREFERRED_VERSION!,
  REACT_APP_DEFAULT_VERSION: process.env.REACT_APP_DEFAULT_VERSION!,
  REACT_APP_BASEURL: process.env.REACT_APP_BASEURL!,
  REACT_APP_SANDBOXURL: process.env.REACT_APP_SANDBOXURL!,
  REACT_APP_SANDBOX_BACKEND_URL: process.env.REACT_APP_SANDBOX_BACKEND_URL!,
  REACT_APP_ALLOWED_ORIGINS: process.env.REACT_APP_ALLOWED_ORIGINS!
}

export const sampleUserId = "iTwinPlatform";
